// extracted by mini-css-extract-plugin
export default {"contenedor":"styles_contenedor__pbqHa","buttonContainer":"styles_buttonContainer__pkoCJ","texto":"styles_texto__+8wXu"};